import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyPointsName',
  initialState: null as string | null,
  reducers: {
    setLoyaltyPointsName(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setLoyaltyPointsName } = slice.actions;

export default slice.reducer;
